import { Component } from '@angular/core';

@Component({
  selector: 'app-suscribe-newsletter',
  standalone: true,
  imports: [],
  templateUrl: './suscribe-newsletter.component.html',
  styleUrl: './suscribe-newsletter.component.css'
})
export class SuscribeNewsletterComponent {

}
